import axios from 'axios';

const API_URL = process.env.REACT_APP_BASE_URL;

const getHeaders = (token) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json'
});

const handleError = (error) => {
  console.error('Agent User API Error:', error);
  return {
    success: false,
    error: error.response?.data?.message || error.message || 'Operation failed'
  };
};

export const assignUserToAgent = async (token, userId, agentId, role) => {
  try {
    const response = await axios.post(
      `${API_URL}/agent-manager/v1/user`,
      {
        user_id: userId,
        agent_id: agentId,
        role: role || 'user'
      },
      { headers: getHeaders(token) }
    );

    return {
      success: response.data.success !== false,
      data: response.data,
      message: response.data.message || 'User assigned to agent successfully'
    };
  } catch (error) {
    return handleError(error);
  }
};

export const getMyAgents = async (token, userId) => {
  try {
    const response = await axios.get(
      `${API_URL}/agent-manager/v1/user/agents?user_id=${userId}`,
      { headers: getHeaders(token) }
    );

    return {
      success: true,
      data: response.data,
      agents: response.data.agents || [],
      total_count: response.data.total_count || 0,
      page: response.data.page || 1,
      total_pages: response.data.total_pages || 1
    };
  } catch (error) {
    return handleError(error);
  }
};

export const removeUserFromAgent = async (token, userId, agentId) => {
  try {
    const response = await axios.delete(
      `${API_URL}/agent-manager/v1/user/${userId}/agent/${agentId}`,
      { headers: getHeaders(token) }
    );

    return {
      success: response.data.success !== false,
      data: response.data,
      message: response.data.message || 'User removed from agent successfully'
    };
  } catch (error) {
    return handleError(error);
  }
};

export const getAgentUsers = async (token, agentId, userId = null) => {
  try {
    let url = `${API_URL}/agent-manager/v1/agent/${agentId}/users`;
    if (userId) {
      url += `?user_id=${userId}`;
    }

    const response = await axios.get(
      url,
      { headers: getHeaders(token) }
    );

    return {
      success: true,
      data: response.data,
      users: response.data.users || [],
      total_count: response.data.total_count || 0,
      page: response.data.page || 1,
      total_pages: response.data.total_pages || 1
    };
  } catch (error) {
    return handleError(error);
  }
};

